import { get } from 'react-hook-form';
import { Get } from 'type-fest';

export const encodeURIObject = (params: Record<string, any>): string => {
  const searchParams: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value == null) continue;

    // Serialize array values as repeated parameters
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item != null) {
          searchParams.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(item)}`
          );
        }
      }
    } else {
      searchParams.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      );
    }
  }

  return searchParams.join('&');
};

export const compareObjects = (a: any, b: any) =>
  JSON.stringify(a) === JSON.stringify(b);

export const getter = <TData, TPath extends string>(
  object: TData,
  path: TPath
) => get(object, path) as Get<TData, TPath>;
